// @ts-nocheck 21b8a716
import * as addPanel from '#packages/oldAddPanel';

export default {
  getDesignSections() {
    return {
      titles: ['design_section_label_explore_footer'],
      sections: [
        addPanel.sections.getSections().designPanelOnly.footerStyleSection,
      ],
    };
  },
};
